document.addEventListener('DOMContentLoaded', function () {
  console.log('Swiper Ready');

  function addInitializedClass(swiper) {
    swiper.el.classList.add('initialized');
  }

  function updatePaginationActive(paginationSelector, activeIndex) {
    const bullets = document.querySelectorAll(`${paginationSelector} .swiper-pagination-bullet`);
    bullets.forEach((bullet, index) => {
      bullet.classList.toggle('swiper-pagination-bullet-active', index === activeIndex);
    });
  }

  if (document.querySelector('.gallery-swiper')) {
    // 총 슬라이드 개수 계산
    const totalSlides = document.querySelectorAll('.gallery-swiper .swiper-slide').length;

    new Swiper('.gallery-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: false,
      loop: false,
      pagination: {
        el: '.gallery-swiper-pagination',
        type: 'custom',
        renderCustom: function (swiper, current, total) {
          // 숫자를 최소 2자리로 포맷
          const currentNum = String(current).padStart(2, '0');
          const totalNum = String(total).padStart(2, '0');
          return '(' + currentNum + ' / ' + totalNum + ')';
        },
      },
      navigation: {
        nextEl: '.gallery-swiper-button-next',
        prevEl: '.gallery-swiper-button-prev',
      },
      on: {
        init: function (swiper) {
          addInitializedClass(swiper);
        },
        slideChange: function () {
          updatePaginationActive('.gallery-swiper-pagination', this.activeIndex);
        },
      },
    });
  }
});
